import React from 'react';
import styled from 'styled-components';
import { Link, graphql, useStaticQuery } from 'gatsby';

import slugify from '@components/slugify';

export const useTags = () => {
  const tags = useStaticQuery(graphql`{
    allMdx(filter: { fields: { posttype: { eq: "blog" } } }) {
      group(field: { frontmatter: { tags: SELECT } }) {
        fieldValue
        totalCount
      }
    }
  }
  `);

  return tags;
};

export const TagBreadcrumb = styled(Link)`
  float: left;
  border: 1px solid ${p => (p.theme.dark ? p.theme.primaryColor : '#d9e0ff')};
  border-radius: 50px;
  padding: 8px 13px;
  line-height: 10px;
  margin: 5px;
  font-weight: 600;
  font-size: 12px;
  i {
    color: ${p => (p.theme.dark ? 'white' : 'grey' )};
  }

  &:hover {
    background: ${p => (p.theme.dark ? p.theme.primaryColor : '#d9e0ff')};
    color: ${p => (p.theme.dark ? '#d9e0ff' : '#1eabb2')};
  }
`;

const Tags = () => {
  const tags = useTags();
  const minimumTagCount = 3;

  return (
    <section style={{ overflow: 'auto' }}>
      {tags.allMdx.group.map(tag => 
        tag.totalCount >= minimumTagCount ? (
        <TagBreadcrumb key={tag.fieldValue} to={`/category/blog/${slugify(tag.fieldValue)}/`}>
          {tag.fieldValue} <i>({tag.totalCount})</i>
        </TagBreadcrumb>
      ) : undefined )}
    </section>
  );
};

export default Tags;
